/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {KIND} from 'baseui/notification'
import {setLoading} from './app-slice'
import {setNotification} from './notification-slice'

export const loginWithCredentials = credentials => async (dispatch, getState, {getFirebase}) => {
  const firebase = getFirebase()

  try {
    dispatch(setLoading({loading: true}))
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    await firebase.login(credentials)
  } catch (error) {
    dispatch(setNotification({code: error.code, message: error.message, kind: KIND.negative}))
  } finally {
    dispatch(setLoading({loading: false}))
  }
}

export const updateUserProfile = profileUpdates => async (dispatch, getState, {getFirebase}) => {
  const firebase = getFirebase()
  try {
    dispatch(setLoading({loading: true}))
    await firebase.updateProfile(profileUpdates)
  } catch (error) {
    dispatch(
      setNotification({
        code: error.code,
        message: error.message,
        kind: KIND.negative,
      }),
    )
  } finally {
    dispatch(setLoading({loading: false}))
  }
}
